import io from "socket.io-client"
import { apiUrl } from "./utils/apiUrl"

const url = apiUrl("", "socket")
// const url = 'https://socket-improve.krino.ai/'
// const url = 'http://localhost:3001'

console.log("Intentando conectar a Socket.IO en:", url)

// Configuración mejorada con opciones de reconexión
export const socket = io(url, {
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  timeout: 20000,
  // Configuraciones adicionales para mejorar la estabilidad
  forceNew: false,
  autoConnect: true,
  // Asegurar que los eventos se emitan incluso si no hay listeners
  emitBufferMax: 1000,
})

// Eventos de conexión
socket.on("connect", () => {
  console.log("✅ Socket conectado exitosamente. ID:", socket.id)

  // Verificar si estamos en una sala específica
  if (socket.rooms) {
    console.log("Salas actuales:", Array.from(socket.rooms))
  }
})

socket.on("connect_error", (error) => {
  console.error("❌ Error de conexión Socket.IO:", error.message)
})

socket.on("connect_timeout", () => {
  console.error("⏱️ Timeout en la conexión Socket.IO")
})

socket.on("reconnect", (attemptNumber) => {
  console.log(`🔄 Socket reconectado después de ${attemptNumber} intentos`)

  // Intentar recuperar el chatId actual de la URL
  const pathParts = window.location.pathname.split("/")
  const chatIdFromUrl = pathParts.find((part) => /^\d+$/.test(part))

  if (chatIdFromUrl) {
    console.log("Recuperando conexión para chat:", chatIdFromUrl)
    // Obtener userId del store (esto dependerá de cómo accedas a Redux fuera de componentes)
    const userId = localStorage.getItem("userId") // Ejemplo, ajusta según tu implementación

    if (userId) {
      console.log("Reconectando con userId:", userId)
      joinChat(Number(chatIdFromUrl), userId, (ack) => {
        console.log("Reconexión a chat completada:", ack)
      })
    } else {
      console.warn("No se encontró userId para reconexión")
    }
  }
})

socket.on("reconnect_attempt", (attemptNumber) => {
  console.log(`🔄 Intento de reconexión #${attemptNumber}`)
})

socket.on("reconnect_error", (error) => {
  console.error("❌ Error en la reconexión:", error.message)
})

socket.on("reconnect_failed", () => {
  console.error("❌ Falló la reconexión después de todos los intentos")
})

socket.on("disconnect", (reason) => {
  console.log(`🔌 Socket desconectado. Razón: ${reason}`)
  if (reason === "io server disconnect") {
    // El servidor desconectó intencionalmente, reconectar manualmente
    console.log("Intentando reconectar manualmente...")
    socket.connect()
  }
})

// Eventos específicos de tu aplicación - ESCUCHAR SIEMPRE
socket.on("mensaje-wsp", (data) => {
  console.log("📩 Mensaje WhatsApp recibido:", data)
  // Disparar evento personalizado para que otros componentes puedan escuchar
  window.dispatchEvent(new CustomEvent('socket-mensaje-wsp', { detail: data }))
})

socket.on("mensaje-personal", (data) => {
  console.log("📩 Mensaje personal recibido:", data)
  // Disparar evento personalizado para que otros componentes puedan escuchar
  window.dispatchEvent(new CustomEvent('socket-mensaje-personal', { detail: data }))
})

socket.on("nueva-conexion", (data) => {
  console.log("🔔 Nueva conexión recibida:", data)
  // Disparar evento personalizado
  window.dispatchEvent(new CustomEvent('socket-nueva-conexion', { detail: data }))
})

socket.on("ejecutivo-asignado", (data) => {
  console.log("👤 Ejecutivo asignado:", data)
  // Disparar evento personalizado
  window.dispatchEvent(new CustomEvent('socket-ejecutivo-asignado', { detail: data }))
})

socket.on("asignacion-ejecutivo", (data) => {
  console.log("👤 Asignación ejecutivo recibida:", data)
  // Disparar evento personalizado
  window.dispatchEvent(new CustomEvent('socket-asignacion-ejecutivo', { detail: data }))
})

socket.on("chat-cerrado", (data) => {
  console.log("🔒 Chat cerrado recibido:", data)
  // Disparar evento personalizado
  window.dispatchEvent(new CustomEvent('socket-chat-cerrado', { detail: data }))
})

socket.on("chat-reactivado", (data) => {
  console.log("🔄 Chat reactivado recibido:", data)
  // Disparar evento personalizado
  window.dispatchEvent(new CustomEvent('socket-chat-reactivado', { detail: data }))
})

// Función de ayuda para depuración
export const debugSocket = {
  emitWithAck: (event, data) => {
    console.log(`Emitiendo evento "${event}" con datos:`, data)
    return new Promise((resolve, reject) => {
      socket.emit(event, data, (response) => {
        console.log(`Respuesta de "${event}":`, response)
        resolve(response)
      })
      // Timeout para la respuesta
      setTimeout(() => {
        reject(new Error(`No se recibió respuesta para el evento "${event}" después de 5 segundos`))
      }, 5000)
    })
  },

  checkConnection: () => {
    const status = {
      connected: socket.connected,
      id: socket.id,
      rooms: socket.rooms ? Array.from(socket.rooms) : [],
      disconnected: socket.disconnected,
    }
    console.log("Estado actual del socket:", status)
    return status
  },

  forceReconnect: () => {
    console.log("Forzando reconexión del socket...")
    socket.disconnect()
    setTimeout(() => {
      socket.connect()
    }, 1000)
  },
}

// Verificar estado inicial después de un tiempo
setTimeout(() => {
  if (!socket.connected) {
    console.warn("⚠️ Socket no conectado después de 5 segundos. Estado:", debugSocket.checkConnection())
  }
}, 5000)

// Verificar si estamos en una sala específica
export const isInRoom = (chatId) => {
  if (!socket.connected) return false

  // En Socket.IO v4, las salas se almacenan en socket.rooms
  if (socket.rooms) {
    const roomName = String(chatId)
    return socket.rooms.has(roomName)
  }

  return false
}

// Función para depurar las salas actuales
export const debugRooms = () => {
  if (!socket.connected) {
    console.log("Socket no conectado, no hay salas")
    return []
  }

  if (socket.rooms) {
    const rooms = Array.from(socket.rooms)
    console.log("Salas actuales:", rooms)
    return rooms
  }

  console.log("No se encontraron salas")
  return []
}

// Agregar una función de ayuda para unirse a chats de manera más robusta
export const joinChat = (chatId, userId, callback = () => {}) => {
  const roomId = Number(chatId)

  if (!socket.connected) {
    console.warn("Socket no conectado. Intentando conectar...")
    socket.connect()

    // Esperar a que se conecte antes de unirse
    socket.once("connect", () => {
      console.log("Socket conectado. Ahora uniéndose al chat:", roomId)
      socket.emit("join-chat", { chatId: roomId, userId }, callback)
    })

    return
  }

  // Verificar si ya estamos en la sala
  if (isInRoom(roomId)) {
    console.log("Ya estamos en la sala:", roomId)
    callback({ status: "already-joined" })
    return
  }

  console.log("Emitiendo join-chat para:", roomId, "usuario:", userId)
  socket.emit("join-chat", { chatId: roomId, userId }, callback)
}

// Función para forzar la reconexión a un chat específico
export const forceJoinChat = (chatId, userId, callback = () => {}) => {
  if (!chatId || !userId) {
    console.error("Se requiere chatId y userId para unirse al chat")
    return
  }

  console.log("Forzando unión al chat:", chatId)

  // Primero verificar si el socket está conectado
  if (!socket.connected) {
    console.log("Socket no conectado, intentando conectar...")
    socket.connect()

    // Esperar a que se conecte antes de unirse
    socket.once("connect", () => {
      console.log("Socket conectado. Ahora uniéndose al chat:", chatId)
      joinChat(Number(chatId), userId, callback)
    })
    return
  }

  // Si ya está conectado, intentar unirse directamente
  joinChat(Number(chatId), userId, (response) => {
    console.log("Respuesta de join-chat forzado:", response)

    // Si hay un error, intentar nuevamente después de salir
    if (response && response.error) {
      console.log("Error al unirse, intentando salir y volver a unirse...")
      socket.emit("leave-chat", { chatId: Number(chatId), userId })

      setTimeout(() => {
        console.log("Reintentando unirse después de salir...")
        joinChat(Number(chatId), userId, callback)
      }, 500)
      return
    }

    // Si todo va bien, llamar al callback
    callback(response)
  })
}

// Función para emitir mensajes de forma robusta
export const emitMessage = (event, data, callback = () => {}) => {
  if (!socket.connected) {
    console.warn("Socket no conectado, guardando mensaje en buffer...")
    // El socket automáticamente buffereará el mensaje
  }
  
  console.log(`Emitiendo ${event}:`, data)
  socket.emit(event, data, callback)
}

// Función para escuchar eventos de forma global
export const listenToGlobalEvents = (eventName, handler) => {
  const eventHandler = (event) => {
    handler(event.detail)
  }
  
  window.addEventListener(eventName, eventHandler)
  
  // Retornar función para remover el listener
  return () => {
    window.removeEventListener(eventName, eventHandler)
  }
}

// Exportar la función para usarla en otros archivos
